module.exports = __webpack_public_path__ + "media/interested_companies/images/star06-e31d1409d142fabd7d491eb8eeb25083.svg";